import { GlBadge, GlIcon, GlSprintf, GlTooltipDirective as GlTooltip } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __, n__, sprintf } from '~/locale';
export default {
    name: 'DiscussionsBadge',
    components: {
        GlBadge,
        GlIcon,
        GlSprintf
    },
    directives: {
        GlTooltip
    },
    props: {
        mergeRequest: {
            type: Object,
            required: true
        },
        /**
     * Renders a subtle icon and count instead of the badge, for dense lists where a
     * coloured pill would compete with the merge request title for attention.
     */ neutral: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        neutralText () {
            return sprintf(__('%{resolvedDiscussionsCount} of %{resolvableDiscussionsCount}'), {
                resolvedDiscussionsCount: this.mergeRequest.resolvedDiscussionsCount,
                resolvableDiscussionsCount: this.mergeRequest.resolvableDiscussionsCount
            });
        },
        isResolved () {
            return this.mergeRequest.resolvedDiscussionsCount === this.mergeRequest.resolvableDiscussionsCount;
        },
        badgeVariant () {
            return this.isResolved ? 'success' : 'neutral';
        },
        tooltipTitle () {
            if (this.isResolved) {
                return sprintf(n__('The only thread is resolved', 'All %{resolvableDiscussionsCount} threads resolved', this.mergeRequest.resolvableDiscussionsCount), {
                    resolvableDiscussionsCount: this.mergeRequest.resolvableDiscussionsCount
                });
            }
            return sprintf(n__('%{resolvedDiscussionsCount} of %{resolvableDiscussionsCount} thread resolved', '%{resolvedDiscussionsCount} of %{resolvableDiscussionsCount} threads resolved', this.mergeRequest.resolvableDiscussionsCount), {
                resolvedDiscussionsCount: this.mergeRequest.resolvedDiscussionsCount,
                resolvableDiscussionsCount: this.mergeRequest.resolvableDiscussionsCount
            });
        }
    }
};
